import { ChangeEvent } from 'react';
import { FormCheck } from 'react-bootstrap';
import { CellProps } from 'react-table';

const OwnExpensCell = ({ row, tableOptions }: CellProps<any>) => {
	const { updateRowData } = tableOptions;
	const rowData = row.original;

	return (
		<FormCheck
			type="checkbox"
			name={`isOwnExpenses-${row.index}`}
			checked={rowData?.isOwnExpenses}
			onChange={(e: ChangeEvent<HTMLInputElement>) => {
				updateRowData(row.index, "isOwnExpenses", e.target.checked);
			}}
			className="d-flex align-items-center justify-content-center"
		/>
	);
};

export default OwnExpensCell;
